/* npm i node-sass@4.8.1 */
import {enableProdMode} from '@angular/core';
import {environment} from './environments/environment';


if (environment.production) {
  enableProdMode();
}

import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {AppModule} from './app/app.module';
platformBrowserDynamic().bootstrapModule(AppModule);




// WEBPACK FOOTER //
// /home/estandar/web/tuhogaronline.tk/public_html/adminTHO/src/main.ts